import { QueryClientProvider } from "@tanstack/react-query";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useEffect } from "react";
import { Toaster } from "sonner";

import { ErrorBoundary } from "@/components/error-boundary";
import { NotFound } from "@/components/not-found";
import { NotificationsBootstrap } from "@/components/notifications-bootstrap";
import { queryClient } from "@/lib/queryClient";
import { useAuth } from "@/stores/auth";
import { NewTicketAnnouncer, QueryInvalidator } from "@/ws/use-invalidator";
import { WebSocketProvider } from "@/ws/provider";

function RootLayout() {
  const fetchMe = useAuth((s) => s.fetchMe);
  const isAuthed = useAuth((s) => !!s.user);

  useEffect(() => {
    void fetchMe();
  }, [fetchMe]);

  return (
    <QueryClientProvider client={queryClient}>
      <WebSocketProvider enabled={isAuthed}>
        <QueryInvalidator />
        <NewTicketAnnouncer />
        <NotificationsBootstrap />
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
        <Toaster position="top-right" richColors closeButton />
        {import.meta.env.DEV ? <TanStackRouterDevtools position="bottom-right" /> : null}
      </WebSocketProvider>
    </QueryClientProvider>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
});
